export default __webpack_public_path__ + "static/montserrat-v14-latin-600-0480d2f8a71f38db8633b84d8722e0c2.woff2";